import thunk from 'redux-thunk'
import {applyMiddleware,compose} from 'redux'


const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

let ex = applyMiddleware(thunk)  // Do not allow people to use the redux extension in production

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development'){ 
    ex = composeEnhancers(applyMiddleware(thunk));
}

export default ex;



